class CurrencyCheck extends HTMLElement {
  constructor() {
    super();
    // Extract custom element attributes for currency details
    this.currencySymbol = this.dataset.currencySymbol;
    this.currencyCode = this.dataset.currencyCode;
    this.currencyStyle = this.dataset.currencyStyle;

    // Determine if the currency symbol should appear after the amount
    this.isSymbolAfter = [
      'AOA',
      'AMD',
      'BOB',
      'BGN',
      'HRK',
      'CZK',
      'DKK',
      'HUF',
      'ISK',
      'KZT',
      'KES',
      'MZN',
      'NOK',
      'PLN',
      'RON',
      'SEK',
      'TZS',
      'UGX',
      'VND',
    ].includes(this.currencyCode);
  }

  connectedCallback() {
    // Trigger currency conversion when the element is added to the DOM
    this.convertCurrency();
  }

  convertCurrency() {
    const content = this.innerHTML; // Get the content within the custom element
    const amountMatch = content.match(/\$(\d+(?:\.\d{1,2})?)/); // Match dollar amounts (e.g., "$100.00")

    if (amountMatch) {
      const amount = parseFloat(amountMatch[1]); // Extract the numeric amount
      const convertedAmount = this.convertAmount(amount); // Convert the amount based on the currency rate

      if (convertedAmount !== null) {
        // Update the element content with the formatted currency
        this.updateContent(content, '$', amount, convertedAmount);
      }
    }
  }

  convertAmount(amount) {
    // Get the currency conversion rate from Shopify's global object
    const rate = window.Shopify?.currency?.rate;
    const converted = rate ? (amount * rate).toFixed(2) : null;

    // Remove trailing decimals if the amount is an integer (e.g., "100.00" => 100)
    return converted && converted.endsWith('.00') ? parseInt(converted, 10) : converted;
  }

  updateContent(originalContent, symbol, originalAmount, convertedAmount) {
    let formattedAmount;

    // Format the converted amount based on the specified currency style
    switch (this.currencyStyle) {
      case 'currency_code_before':
        formattedAmount = this.isSymbolAfter
          ? `${this.currencyCode} ${convertedAmount} ${this.currencySymbol}`
          : `${this.currencyCode} ${this.currencySymbol}${convertedAmount}`;
        break;
      case 'currency_code_after':
        formattedAmount = this.isSymbolAfter
          ? `${convertedAmount} ${this.currencySymbol} ${this.currencyCode}`
          : `${this.currencySymbol}${convertedAmount} ${this.currencyCode}`;
        break;
      default:
        formattedAmount = this.isSymbolAfter
          ? `${convertedAmount} ${this.currencySymbol}`
          : `${this.currencySymbol}${convertedAmount}`;
    }

    // Replace the original content with the formatted currency
    this.innerHTML = originalContent.replace(`${symbol}${originalAmount}`, formattedAmount);
  }
}

// Define the custom element 'fx-currencycheck'
customElements.define('fx-currencycheck', CurrencyCheck);
